var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-error-container"},[_c('div',{staticClass:"page-error"},[(!_vm.error || _vm.error.includes('403'))?_c('div',[_vm._m(0),_c('h2',[_vm._v("The page you requested could not found")])]):_c('div',[_c('h2',[_vm._v(_vm._s(_vm.error))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-404"},[_c('h1',[_vm._v("4"),_c('span',[_vm._v("0")]),_vm._v("4")])])
}]

export { render, staticRenderFns }